import { P2GText } from '@parcel2go/core-ui';

import { ProviderGroup } from '../../../../lib/helpers/SmartSendBulkActionApplier';
import { AsyncLinks } from './AsyncLinks';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { P2GGrid } from '@parcel2go/core-ui';
import useGoto from '~/hooks/use-goto';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import ProviderGroupSummaryInvoice from './ProviderGroupSummaryInvoice';

interface props {
  group: ProviderGroup;
}

const ProviderGroupSummaryBookedLinks: React.FC<props> = (props) => {
  const { goTo } = useGoto();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    <>
      {props.group.Manifestable && SettingsCache.settings.Features.includes('Manifests') && (
        <AsyncLinks
          wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}
          variant="list"
          tag={`Order ${props.group.ShipResponse.Reference}`}
          links={[
            {
              Label: `Review\nManifest`,
              Type: 'GOTO-MANIFESTS',
              OnClick: () => goTo(RoutingConstants.Manifests)
            }
          ]}
          title={null}
          match={null}
        >
          <P2GText component="p" colour="primary">
            <Trans t={t} i18nKey="PROVIDER_SUMMARY_WHAT_NEXT" defaults="<strong>What Next?</strong>" />
          </P2GText>
        </AsyncLinks>
      )}

      <ProviderGroupSummaryInvoice
        shipResponse={props.group.ShipResponse}
        wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}
      />

      {(SettingsCache.settings.Features.includes('PickingList') ||
        SettingsCache.settings.Features.includes('PackageContents')) && (
        <AsyncLinks
          wrapper={(x) => <P2GGrid item>{x}</P2GGrid>}
          variant="list"
          tag={`Order ${props.group.ShipResponse.Reference}`}
          links={props.group.ShipResponse?.Links.concat([
            {
              Label: `View Pick\nand Pack`,
              Type: 'GOTO-PICKANDPACK_ONCLICK',
              OnClick: () => goTo(RoutingConstants.PackageContents)
            } as any
          ])}
          title={null}
          match={(x) => {
            return (
              (SettingsCache.settings.Features.includes('PickingList') &&
                x.Type.startsWith('ORDER-PICKINGLIST_DOWNLOAD')) ||
              (SettingsCache.settings.Features.includes('PackageContents') &&
                x.Type.startsWith('GOTO-PICKANDPACK_ONCLICK'))
            );
          }}
        >
          <P2GText component="p" colour="primary">
            <strong>
              <Trans t={t} i18nKey="PROVIDER_SUMMARY_PICKING_LIST" defaults="Picking and Packing" />
            </strong>
          </P2GText>
        </AsyncLinks>
      )}
    </>
  );
};

export default ProviderGroupSummaryBookedLinks;
